import { render, staticRenderFns } from "./ScoutResumeCard.vue?vue&type=template&id=3bc18106"
import script from "./ScoutResumeCard.vue?vue&type=script&lang=js"
export * from "./ScoutResumeCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports